import * as Yup from 'yup'
import { getInitialState } from '../../../utils/formikUpdate'

export const datasetFormik = async () => {
  const STEP1_FIELDS = [
    {
      x: 12,
      name: 'nombre',
      initvalue: '',
      label: 'Nombre del País *',
    },
    {
      x: 6,
      name: 'slug',
      initvalue: '',
      label: 'Slug (URL)',
      helperText: 'Opcional, se genera automáticamente',
    },
    {
      x: 3,
      name: 'codigo_iso2',
      initvalue: '',
      label: 'Código ISO2',
      helperText: 'Opcional (2 letras)',
    },
    {
      x: 3,
      name: 'codigo_iso3',
      initvalue: '',
      label: 'Código ISO3',
      helperText: 'Opcional (3 letras)',
    },
    {
      x: 4,
      name: 'label_n1',
      initvalue: '',
      label: 'Etiqueta Nivel 1 *',
      helperText: 'Ej: Provincia/Estado',
    },
    {
      x: 4,
      name: 'label_n2',
      initvalue: '',
      label: 'Etiqueta Nivel 2 *',
      helperText: 'Ej: Cantón/Departamento',
    },
    {
      x: 4,
      name: 'label_n3',
      initvalue: '',
      label: 'Etiqueta Nivel 3 *',
      helperText: 'Ej: Parroquia/Municipio',
    },
    {
      x: 4,
      name: 'center_lat',
      initvalue: '',
      label: 'Latitud Centro',
      helperText: 'Ej: -1.831239',
      type: 'number',
    },
    {
      x: 4,
      name: 'center_lng',
      initvalue: '',
      label: 'Longitud Centro',
      helperText: 'Ej: -78.183406',
      type: 'number',
    },
    {
      x: 4,
      name: 'zoom',
      initvalue: 6,
      label: 'Zoom inicial',
      helperText: 'Ej: 6 (0-22)',
      type: 'number',
    },
    {
      x: 6,
      name: 'habilitado',
      initvalue: 1,
      label: 'Estado',
      options: { 0: 'Desactivado', 1: 'Activado' },
    },
    {
      x: 6,
      name: 'orden',
      initvalue: '',
      label: 'Orden',
      helperText: 'Opcional (0-255)',
      type: 'number',
    },
    {
      x: 12,
      name: 'icono_svg',
      initvalue: '',
    },
  ]

  const ITEMS_COUNTRY_FORMIK = [...STEP1_FIELDS]
  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_COUNTRY_FORMIK)

  const STEP1_VALIDATION = Yup.object().shape({
    nombre: Yup.string()
      .min(2, 'Mínimo 2 caracteres')
      .max(100, 'Máximo 100 caracteres')
      .required('Obligatorio'),
    slug: Yup.string()
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres')
      .matches(/^[a-z0-9-]+$/, 'Solo letras minúsculas, números y guiones')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value)),
    codigo_iso2: Yup.string()
      .length(2, 'Debe tener 2 caracteres')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value)),
    codigo_iso3: Yup.string()
      .length(3, 'Debe tener 3 caracteres')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value)),
    label_n1: Yup.string()
      .max(50, 'Máximo 50 caracteres')
      .required('Obligatorio'),
    label_n2: Yup.string()
      .max(50, 'Máximo 50 caracteres')
      .required('Obligatorio'),
    label_n3: Yup.string()
      .max(50, 'Máximo 50 caracteres')
      .required('Obligatorio'),
    center_lat: Yup.number()
      .min(-90, 'Mínimo -90')
      .max(90, 'Máximo 90')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .typeError('Debe ser un número'),
    center_lng: Yup.number()
      .min(-180, 'Mínimo -180')
      .max(180, 'Máximo 180')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .typeError('Debe ser un número'),
    zoom: Yup.number()
      .min(0, 'Mínimo 0')
      .max(22, 'Máximo 22')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .typeError('Debe ser un número'),
    orden: Yup.number()
      .min(0, 'Mínimo 0')
      .max(255, 'Máximo 255')
      .nullable()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .typeError('Debe ser un número'),
    icono_svg: Yup.string()
      .min(10, 'SVG muy corto')
      .required('El ícono SVG es obligatorio'),
  })

  const FORM_VALIDATION = STEP1_VALIDATION

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_COUNTRY_FORMIK,
    STEP1_FIELDS,
    STEP1_VALIDATION,
    FORM_VALIDATION,
  }
}
